<!-- Certificate -->
<div class="text-center">
    <h1>RentWise Certficate</h1>
</div>

<div *ngIf="error" class="text-center text-danger pb-4">{{error}}</div>

<pdf-viewer *ngIf="loaded && src" class="test" [src]="src" [render-text]="true" [original-size]="true" style="width: 100%; height: 100%; ">
</pdf-viewer>

<div class="navigate-buttons text-center" *ngIf="!loading">
    <button type="button" class="btn waves-dark w-25" [routerLink]="'/courses/RentWise'">Back to Course</button>
    <button type="button" class="btn waves-dark w-25" (click)="downloadPdf()">Download PDF</button>
</div>
